import { IDettaglio } from "../../../interfaces/dettaglio/models";

export const GET = "dettaglio/get";
export const LIST = "dettaglio/list";
export const LIST_SOLD = "dettaglio/list_sold";
export const EMPTY = "dettaglio/empty";

export interface IDettaglioState {
  results: number;
  groupedResults: number;
  soldResults: number;
  list: number[];
  groupedList: number[];
  soldList: number[];
  items: Record<number, IDettaglio> | null;
  groupedItems: Record<number, IDettaglio> | null;
  soldItems: Record<number, IDettaglio> | null;
}

export interface IDettaglioListPayload {
  results: number;
  list: number[];
  items: Record<number, IDettaglio> | null;
  groupedResults: number;
  groupedList: number[];
  groupedItems: Record<number, IDettaglio> | null;
}

export interface IDettaglioListSoldPayload {
  soldResults: number;
  soldList: number[];
  soldItems: Record<number, IDettaglio> | null;
}

export const initialState: IDettaglioState = {
  results: 0,
  groupedResults: 0,
  soldResults: 0,
  list: [],
  groupedList: [],
  soldList: [],
  items: null,
  groupedItems: null,
  soldItems: null,
};
